const countryTranslations = {
  ad: "Andorra nutome",
  ae: "United Arab Emirates nutome",
  af: "Afghanistan nutome",
  ag: "́Antigua kple Barbuda nutome",
  ai: "Anguilla nutome",
  al: "Albania nutome",
  am: "Armenia nutome",
  ao: "Angola nutome",
  ar: "Argentina nutome",
  as: "Amerika Samoa nutome",
  at: "Austria nutome",
  au: "Australia nutome",
  aw: "Aruba nutome",
  ax: "Åland ƒudomekpo nutome",
  az: "Azerbaijan nutome",
  ba: "Bosnia kple Herzergovina nutome",
  bb: "Barbados nutome",
  bd: "Bangladesh nutome",
  be: "Belgium nutome",
  bf: "Burkina Faso nutome",
  bg: "Bulgaria nutome",
  bh: "Bahrain nutome",
  bi: "Burundi nutome",
  bj: "Benin nutome",
  bl: "Saint Barthélemy nutome",
  bm: "Bermuda nutome",
  bn: "Brunei nutome",
  bo: "Bolivia nutome",
  bq: "Caribbean Netherlands",
  br: "Brazil nutome",
  bs: "Bahamas nutome",
  bt: "Bhutan nutome",
  bw: "Botswana nutome",
  by: "Belarus nutome",
  bz: "Belize nutome",
  ca: "Canada nutome",
  cc: "Kokos (Kiling) fudomekpo nutome",
  cd: "Kongo Kinshasa nutome",
  cf: "Titina Afrika repɔblik nutome",
  cg: "Kongo Brazzaville nutome",
  ch: "Switzerland nutome",
  ci: "Kote d’Ivoire nutome",
  ck: "Kook ƒudomekpo nutome",
  cl: "Tsile nutome",
  cm: "Kamerun nutome",
  cn: "Tsaina nutome",
  co: "Kolombia nutome",
  cr: "Kosta Rika nutome",
  cu: "Kuba nutome",
  cv: "Kape Verde nutome",
  cw: "Curaçao",
  cx: "Kristmas ƒudomekpo nutome",
  cy: "Saiprus nutome",
  cz: "Tsɛk repɔblik nutome",
  de: "Germania nutome",
  dj: "Dzibuti nutome",
  dk: "Denmark nutome",
  dm: "Dominika nutome",
  do: "Dominika repɔblik nutome",
  dz: "Algeria nutome",
  ec: "Ekuadɔ nutome",
  ee: "Estonia nutome",
  eg: "Egypte nutome",
  eh: "Ɣetoɖoƒe Sahara nutome",
  er: "Eritrea nutome",
  es: "Spain nutome",
  et: "Etiopia nutome",
  fi: "Finland nutome",
  fj: "Fidzi nutome",
  fk: "Falkland ƒudomekpowo nutome",
  fm: "Mikronesia nutome",
  fo: "Faroe ƒudomekpowo nutome",
  fr: "France nutome",
  ga: "Gabɔn nutome",
  gb: "United Kingdom nutome",
  gd: "Grenada nutome",
  ge: "Georgia nutome",
  gf: "Frentsi Gayana nutome",
  gg: "Guernse nutome",
  gh: "Ghana nutome",
  gi: "Gibraltar nutome",
  gl: "Grinland nutome",
  gm: "Gambia nutome",
  gn: "Guini nutome",
  gp: "Guadelupe nutome",
  gq: "Ekuatorial Guini nutome",
  gr: "Greece nutome",
  gt: "Guatemala nutome",
  gu: "Guam nutome",
  gw: "Gini-Bisao nutome",
  gy: "Guyanadu",
  hk: "Hɔng Kɔng SAR Tsaina nutome",
  hn: "Hondurasdu",
  hr: "Kroatsia nutome",
  ht: "Haiti nutome",
  hu: "Hungari nutome",
  id: "Indonesia nutome",
  ie: "Ireland nutome",
  il: "Israel nutome",
  im: "Aisle of Man nutome",
  in: "India nutome",
  io: "Britaintɔwo ƒe india ƒudome nutome",
  iq: "iraqdukɔ",
  ir: "Iran nutome",
  is: "Aiseland nutome",
  it: "Italia nutome",
  je: "Dzɛse nutome",
  jm: "Dzamaika nutome",
  jo: "Yordan nutome",
  jp: "Dzapan nutome",
  ke: "Kenya nutome",
  kg: "Kirgizstan nutome",
  kh: "Kambodia nutome",
  ki: "Kiribati nutome",
  km: "Komoros nutome",
  kn: "Saint Kitis kple Nevis nutome",
  kp: "Dziehe Korea nutome",
  kr: "Anyiehe Korea nutome",
  kw: "Kuwait nutome",
  ky: "Kayman ƒudomekpowo nutome",
  kz: "Kazakstan nutome",
  la: "Laos nutome",
  lb: "Lebanɔn nutome",
  lc: "Saint Lusia nutome",
  li: "Litsenstein nutome",
  lk: "Sri Lanka nutome",
  lr: "Liberia nutome",
  ls: "Lɛsoto nutome",
  lt: "Lituania nutome",
  lu: "Lazembɔg nutome",
  lv: "Latvia nutome",
  ly: "Libya nutome",
  ma: "Moroko nutome",
  mc: "Monako nutome",
  md: "Moldova nutome",
  me: "Montenegro nutome",
  mf: "Saint Martin nutome",
  mg: "Madagaska nutome",
  mh: "Marshal ƒudomekpowo nutome",
  mk: "North Macedonia",
  ml: "Mali nutome",
  mm: "Myanmar (Burma) nutome",
  mn: "Mongolia nutome",
  mo: "Macau SAR Tsaina nutome",
  mp: "Dziehe Marina ƒudomekpowo nutome",
  mq: "Martiniki nutome",
  mr: "Mauritania nutome",
  ms: "Montserrat nutome",
  mt: "Malta nutome",
  mu: "mauritiusdukɔ",
  mv: "maldivesdukɔ",
  mw: "Malawi nutome",
  mx: "Mexico nutome",
  my: "Malaysia nutome",
  mz: "Mozambiki nutome",
  na: "Namibia nutome",
  nc: "New Kaledonia nutome",
  ne: "Niger nutome",
  nf: "Norfolk ƒudomekpo nutome",
  ng: "Nigeria nutome",
  ni: "Nicaraguadukɔ",
  nl: "Netherlands nutome",
  no: "Norway nutome",
  np: "Nepal nutome",
  nr: "Nauru nutome",
  nu: "Niue nutome",
  nz: "New Zealand nutome",
  om: "Oman nutome",
  pa: "Panama nutome",
  pe: "Peru nutome",
  pf: "Frentsi Pɔlinesia nutome",
  pg: "Papua New Gini nutome",
  ph: "Filipini nutome",
  pk: "Pakistan nutome",
  pl: "Poland nutome",
  pm: "Saint Pierre kple Mikelɔn nutome",
  pr: "Puerto Riko nutome",
  ps: "Palestinia nutome",
  pt: "Portugal nutome",
  pw: "Palau nutome",
  py: "Paragua nutome",
  qa: "Katar nutome",
  re: "Réunion nutome",
  ro: "Romania nutome",
  rs: "Serbia",
  ru: "Russia nutome",
  rw: "Rwanda nutome",
  sa: "Saudi Arabia nutome",
  sb: "Solomon ƒudomekpowo nutome",
  sc: "Seshɛls nutome",
  sd: "Sudan nutome",
  se: "Sweden nutome",
  sg: "Singapɔr nutome",
  sh: "Saint Helena nutome",
  si: "Slovenia nutome",
  sj: "Svalbard kple Yan Mayen nutome",
  sk: "Slovakia nutome",
  sl: "Sierra Leone nutome",
  sm: "San Marino nutome",
  sn: "Senegal nutome",
  so: "Somalia nutome",
  sr: "Suriname nutome",
  ss: "South Sudan",
  st: "São Tomé kple Príncipe nutome",
  sv: "El Salvadɔ nutome",
  sx: "Sint Maarten",
  sy: "Siria nutome",
  sz: "Swaziland nutome",
  tc: "Tɛks kple Kaikos ƒudomekpowo nutome",
  td: "Tsad nutome",
  tg: "Togo nutome",
  th: "Thailand nutome",
  tj: "Tajikistan nutome",
  tk: "Tokelau nutome",
  tl: "Timor-Leste nutome",
  tm: "Tɛkmenistan nutome",
  tn: "Tunisia nutome",
  to: "Tonga nutome",
  tr: "Tɛki nutome",
  tt: "Trinidad kple Tobago nutome",
  tv: "Tuvalu nutome",
  tw: "Taiwan nutome",
  tz: "Tanzania nutome",
  ua: "Ukraine nutome",
  ug: "Uganda nutome",
  us: "USA nutome",
  uy: "uruguaydukɔ",
  uz: "Uzbekistan nutome",
  va: "Vatikandu nutome",
  vc: "Saint Vincent kple Grenadine nutome",
  ve: "Venezuela nutome",
  vg: "Britaintɔwo ƒe Virgin ƒudomekpowo nutome",
  vi: "U.S. Vɛrgin ƒudomekpowo nutome",
  vn: "Vietnam nutome",
  vu: "Vanuatu nutome",
  wf: "Wallis kple Futuna nutome",
  ws: "Samoa nutome",
  ye: "Yemen nutome",
  yt: "Mayotte nutome",
  za: "Anyiehe Africa nutome",
  zm: "Zambia nutome",
  zw: "Zimbabwe nutome"
};
export default countryTranslations;
